// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"522":"css/app.6663","3836":"css/admin-app.6663"}[chunkId] + ".css";
};